"use client";
import React from "react";
import "./boxstyle.css"; // Ensure this file exists and is styled appropriately

function HowItsWorks() {
  const steps = [
    {
      number: "1",
      image: "empty-wallet-add.png", // Replace with your actual image path or import
      title: "Wallet Connect",
      description: "Connect your crypto wallet (MetaMask or WalletConnect).",
    },
    {
      number: "2",
      image: "money-send.png",
      title: "Choose Amount & Duration",
      description: "Pick how much and how long you want to stake.",
    },
    {
      number: "3",
      image: "security-time.png",
      title: "Start Earning",
      description: "Watch your $BABYU grow with daily magical returns.",
    },
  ];

  return (
    <div className="relative w-full h-auto overflow-x-hidden">
      {/* Background */}
      <div className="w-full min-h-screen sm:bg-[url('../public/Group988.png')] bg-no-repeat bg-center bg-[length:100%_100%]">
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;700;800&family=Inter:wght@400;500;600;700&display=swap"
        />

        <section className="overflow-hidden relative w-full min-h-screen flex justify-center items-center px-4">
          <div className="flex flex-col gap-16 max-w-[1344px] w-full items-start">
            {/* Header Section */}
            <header className="flex flex-col gap-6 justify-center items-start w-full max-w-3xl">
              <h1 className="text-7xl font-bold tracking-wider text-white leading-[72px] max-md:text-6xl max-sm:text-5xl">
                <span className="text-white font-fredoka">How It  </span>
                <span className="font-fredoka text-6xl font-bold bg-clip-text max-md:text-5xl max-sm:text-4xl text-transparent bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
                 Works
                </span>
              </h1>

              {/* SVG Gradient Title */}
              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<svg id="12:1641" width="402" height="29" viewBox="0 0 402 29" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="14.5" r="12" fill="url(#paint0_linear_12_1641)"></circle><circle cx="12" cy="14.5" r="6" fill="#4F416A"></circle><text fill="url(#paint1_linear_12_1641)" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="24" font-weight="500" letter-spacing="0em"><tspan x="34" y="23.2273">3-STEP GUIDE</tspan></text><defs><linearGradient id="paint0_linear_12_1641" x1="4.84729" y1="8.72222" x2="22.9163" y2="8.72222" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA8D1"></stop><stop offset="0.475962" stop-color="#C3B1FF"></stop><stop offset="1" stop-color="#AEE2FF"></stop></linearGradient><linearGradient id="paint1_linear_12_1641" x1="108.325" y1="7.51852" x2="385.383" y2="7.51852" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA8D1"></stop><stop offset="0.475962" stop-color="#C3B1FF"></stop><stop offset="1" stop-color="#AEE2FF"></stop></linearGradient></defs></svg>`,
                  }}
                />
              </div>

              <p className="text-xl text-neutral-100 leading-8 max-md:text-lg max-sm:text-base">
             Connect your wallet, choose how much and how long to stake your $BABYU, and start earning daily rewards. It's safe, simple, and designed to help your tokens grow — the Baby Unicorn way
              </p>
            </header>

            {/* Steps Grid */}
            <div className="flex flex-col md:flex-row md:flex-wrap gap-6 w-full justify-start">
              {steps.map((step) => (
                <article
                  key={step.number}
                  className="flex frame-11 flex-col gap-4 p-6 rounded-xl border-2 border-solid backdrop-blur-[10px] bg-[#3a3350] bg-opacity-60 border-slate-800 border-opacity-10 w-full md:w-[432px]"
                >   <div className="w-full flex justify-start">
    <img
      src={step.image}
      alt={`Step ${step.number}`}
      className="w-[60px] h-[60px] object-contain"
    />
  </div>
                  <header className="flex justify-between items-center w-full">
                    <h2 className="text-3xl font-bold text-white max-md:text-2xl max-sm:text-xl">
                      {step.title}
                    </h2>
                
                  </header>
                  <p className="text-2xl text-neutral-100 leading-8 max-md:text-xl max-sm:text-lg">
                    {step.description}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default HowItsWorks;
